<div class="info">Drag the map below to position the marker.</div>
<div class="form-control agc-disabled">{{ value || 'Not set' }}</div>
<div #map class="map-view"></div>
